/**
 * ThemeVarsContext — carries the resolved `--wb-*` CSS custom properties down to
 * the canvas so the editor preview matches the published render (WYSIWYG). The
 * host app (which owns the site's theme) computes the vars via
 * `resolveTokens(...).cssVars` plus its Duro brand override and provides them;
 * PageNode applies them to each page body, and MoveDragGhost to its clone of a
 * page's content. Only those carry the brand: the editor chrome around them
 * keeps the fleet theme. (AddDragGhost needs none: its previews are images.)
 * Empty by default, so the canvas works unthemed.
 */
import { createContext, useContext } from "react";

export type ThemeVars = Readonly<Record<string, string>>;

const ThemeVarsContext = createContext<ThemeVars>({});

export function ThemeVarsProvider({
  value,
  children,
}: {
  readonly value: ThemeVars;
  readonly children: React.ReactNode;
}) {
  return (
    <ThemeVarsContext.Provider value={value}>
      {children}
    </ThemeVarsContext.Provider>
  );
}

export function useThemeVars(): ThemeVars {
  return useContext(ThemeVarsContext);
}
